import { render, staticRenderFns } from "./DesignerAfterPublishModal.vue?vue&type=template&id=5b07b19c&scoped=true&"
import script from "./DesignerAfterPublishModal.vue?vue&type=script&lang=js&"
export * from "./DesignerAfterPublishModal.vue?vue&type=script&lang=js&"
import style0 from "./DesignerAfterPublishModal.vue?vue&type=style&index=0&id=5b07b19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07b19c",
  null
  
)

export default component.exports